import React from 'react';
import { Button, Table } from 'reactstrap';

interface ActivitylogProps {
  refreshTrigger: boolean;
}

const Activitylog: React.FC<ActivitylogProps> = ({ refreshTrigger }) => {
  // use refreshTrigger as needed inside this component
  return (
    <div>
        <Button className='mb-3' style={{marginLeft:"1450px"}}>Export</Button>
        
     <Table striped hover responsive bordered>
          <thead className="thead-dark">
            <tr>
              <th>SNo</th>
              <th>Action</th>
              <th>Name</th>
              <th>Description</th>
              <th>Time Ago</th>
            </tr>
          </thead>
          </Table>
    </div>
  );
};

export default Activitylog;
